import { create } from "zustand";

interface TaskState {
	selectedTaskId: string;
	activeTab: string;
}

interface TaskActions {
	setActiveTab: (tab: string) => void;
	selectTask: (id: string) => void;
	clearTaskSelection: () => void;
}

export interface TaskStore extends TaskState {
	actions: TaskActions;
}

export const useTaskStore = create<TaskStore>((set) => {
	const state: TaskState = {
		selectedTaskId: "",
		activeTab: "tasks",
	};

	const actions: TaskActions = {
		setActiveTab: (tab: string) => set({ activeTab: tab }),
		selectTask: (id: string) => set({ selectedTaskId: id }),
		clearTaskSelection: () => set({ selectedTaskId: "" }),
	};

	return { ...state, actions };
});

export const useSelectedTaskId = () =>
	useTaskStore((state) => state.selectedTaskId);
export const useActiveTaskTab = () => useTaskStore((state) => state.activeTab);

export const useTaskActions = () => useTaskStore((state) => state.actions);
